import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SpinnerComponent } from './spinner.component';
import { MtnMaterialModule } from '../../modules/mtn-material.module';


@NgModule({
  declarations: [SpinnerComponent],
  exports: [SpinnerComponent],
  imports: [CommonModule, MtnMaterialModule]
})
export class MtnSpinnerModule {
}
